export const releaseNotesLabel = {
  releaseDate: "Release Date",
  version: "Version",
  description: "Description",
  status: "Show release notes to all users.",
};

export const intialReleaseNotes = {
  releaseDate: "",
  version: "",
  description: "",
  status: false,
};

export const releaseNotesRules = [
  {
    field_name: "releaseDate",
    label: releaseNotesLabel.releaseDate,
    type: "String",
    isRequired: true,
  },
  {
    field_name: "version",
    label: releaseNotesLabel.version,
    type: "String",
    isRequired: true,
  },
  {
    field_name: "description",
    label: releaseNotesLabel.description,
    type: "String",
    isRequired: true,
  },
];
